import { useEffect, useState } from "react";
import axios from "axios";
import { getAuthHeader } from "../../utils/authHeader";

/** Counts the listings in the Listings page's answer: three budget lines, then one JSON line per listing. */
export function countListings(body: string): number {
    return body
        .split("\n")
        .map((line) => line.trim())
        .filter(Boolean)
        .slice(3)
        .filter((line) => {
            try {
                const parsed: unknown = JSON.parse(line);
                return typeof parsed === "object" && parsed !== null;
            } catch {
                return false;
            }
        }).length;
}

/**
 * Whether any listing is on the account, campaign or not. Asked only when `enabled` (the campaign list
 * has no property campaign to offer); "checking" while the answer is on its way, null when not asked or failed.
 */
export function useHasListings(enabled: boolean): boolean | "checking" | null {
    const [answer, setAnswer] = useState<boolean | "failed" | null>(null);
    useEffect(() => {
        if (!enabled) return;
        let active = true;
        const ask = async (): Promise<void> => {
            try {
                const headers = await getAuthHeader();
                // The answer is NDJSON, not JSON: take it as text and count the lines.
                const res = await axios.get<string>(`${process.env.REACT_APP_BACKEND_URL}/listing`, {
                    headers,
                    responseType: "text",
                    transformResponse: [(data: unknown) => data],
                });
                if (active) setAnswer(countListings(typeof res.data === "string" ? res.data : "") > 0);
            } catch {
                if (active) setAnswer("failed");
            }
        };
        void ask();
        return () => {
            active = false;
        };
    }, [enabled]);
    if (typeof answer === "boolean") return answer;
    return enabled && answer === null ? "checking" : null;
}
